import React, { useState, useEffect, Fragment } from "react";
import LeadDetailsApt from "components/sales/formSection/leadDetails/leadDetailsApt";
import PocDetails from "components/sales/formSection/pocDetails/pocDetails";
import Location from "components/sales/formSection/location/locationOnboarding";
import CategoryDetails from "components/sales/formSection/categoryDetails/categoryDetails";
import GatesForm from "components/sales/formSection/gates/addgateCreateLead";
import Layout from "components/sales/layout/layout";
import localization from "assets/localization/localization";
import Images from "assets/images/imageData";
import { Button, Table } from "react-bootstrap";
import ModalPop from "components/sales/modal/modal";
import { Link } from "react-router-dom";
import { BaseUrl } from "contexts/baseUrl/baseUrl";
import { useContext } from "react";
import Notfound from "pages/notfound";
import CategoryDetailsCorp from 'components/sales/formSection/categoryDetails/categoryDetailsCorp';
import LeadDetailsSupply from "components/sales/formSection/leadDetails/leadDetailsSupply";
import axios from "services/interceptor/Interceptor";
import Config from "services/config/config";
import LeadDetails from 'components/sales/formSection/leadDetails/leadDetails';
import { toast, ToastContainer } from "react-toastify";
import { handleValidateObj } from 'constants/objValues/objvalues';
import ExistingProjectList from './existingProjectList.js';



const EditApartments = ({
  locationCity,
  cities,
  locationZone,
  zones,
  locationArea,
  areas,
  locationType,
  locTypesData,
  locationState,
  locationPinCode,
  pincodeData,
  rwaTenureFun,
  rwaTenureData,
  appartmentDropDown,
  getApartmentDropDown,
  getCurrentLocation,
  latlng,
  toastMsg,
  editApartmentLeadSubmit,
  getDetails,
  match,
  viewDetails,
  supplyNameFun,
  splNameData,
  getCorporateDropDown,
  getSupplyDropDown,
  corDropDownData,
  pocSubSiteTypeData,
  pocSubSiteType,
  supDropDownData,
  updateProjectOnboarding,
  getExistingProjectListInEdit,
  existingProjectList,


}) => {
  const { baseUrl } = useContext(BaseUrl);
  const [corporateLeadData, setCorporateLeadData] = useState(null);
  const [corporatePocDetails, setCorporatePocDetails] = useState(null);
  const [corporateLocation, setCorporateLocation] = useState(null);
  const [gateDetails, setGateDetails] = useState(null);
  const [corporateCategoryDetails, setCorporateCategoryDetails] = useState(
    null
  );
  const [isFiled, setIsFiled] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRender, setIsRender] = useState(false);
  const [projectType,setProjectType] = useState(null);
  const [projectSubType,setProjectSubType] = useState(null);
  const [isSupply, setIsSupply] = useState(false);
  const [isApt, setIsApt] = useState(false);
  const [showProjectListPopup, setShowProjectListPopup] = useState(false);

  const [details, setDetails] = useState(null);
  useEffect(() => {
      if (existingProjectList) {
        setDetails(existingProjectList?.projects);
      }
    }, [existingProjectList]);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await getSupplyDropDown();
      setIsLoading(false);
    })();
  }, [getSupplyDropDown]);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await getCorporateDropDown();
      setIsLoading(false);
    })();
  }, [getCorporateDropDown]);

  useEffect(() => {
    if (match?.params?.id !== undefined && match?.params?.id !== null) {
     
      (async () => {
        let url = Config.viewDetails.getLeadType;
        const payload = {
          lead_id: match.params.id,
        };
        const { data } = await axios.post(url, payload);
        if(data &&  data.response && data.response.status == true){
          setProjectType(data.response.data.lead_type);
          setProjectSubType(data.response.data.lead_sub_type);
          const leadTypeId = data.response.data.lead_type;
          // (await JSON.parse(localStorage.getItem("viewDetail"))) &&
          // JSON.parse(localStorage.getItem("viewDetail"))[0].lead_type_id;
          const requestData = {
            lead_id: match.params.id,
            lead_type: leadTypeId,
          };
          if (requestData) {
            const res = await getDetails(requestData);
            if (res === null || res === "") {
              setIsRender(true);
            }
          }
        }
       
      })();
    }
  }, [getDetails]);

  // useEffect(() => {
  //   if(viewDetails?.lead_data?.lead_type_id){
  //     setProjectType(viewDetails?.lead_data?.lead_type_id);
  //   }
  // },[viewDetails?.lead_data?.lead_type_id]);

  const handleLeadSubmit = (val) => {
    setCorporateLeadData(val);
  };
  const handlePocSubmit = (val) => setCorporatePocDetails(val);
  const handleLocSubmit = (val) => setCorporateLocation(val);
  const handleCatSubmit = (val) => setCorporateCategoryDetails(val);
  const handleGatesSubmit = (val) => setGateDetails(val);

  const handleModalHide = () => setIsModal(false);

  const getEditFormPayload = () => ({
    ...corporateLeadData,
    ...corporatePocDetails,
    ...corporateLocation,
    ...corporateCategoryDetails,
    ...gateDetails,
  });

  const isEditFormValid = () =>
    corporateLeadData !== null &&
    corporatePocDetails !== null &&
    corporateLocation !== null;

  const handleInvalidForm = () => {
    setIsFiled(true);
    setShowProjectListPopup(false);
    setIsModal(false);
    toast.error('Please fill all the required fields.');
  };

  const handleSubmit = (leadId) => {
    if (!isEditFormValid()) {
      handleInvalidForm();
      return false;
    }
    setIsFiled(false);
    (async () => {
      const res = await updateProjectOnboarding({
        ...getEditFormPayload(),
        leadId: leadId,
        projectType: projectType,
      });
      if (res) {
        setShowProjectListPopup(false);
        setIsModal(true);
      }
    })();
  };

  const checkInfraId = () => {
    if (!isEditFormValid()) {
      handleInvalidForm();
      return;
    }
    (async () => {
      await getExistingProjectListInEdit({
        ...getEditFormPayload(),
        projectType: projectType,
      });
      setShowProjectListPopup(true);
    })();
  };

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await getApartmentDropDown();
      setTimeout(() => setIsLoading(false), 500);
    })();
  }, [getApartmentDropDown]);

  const closePopup = () => {
    setShowProjectListPopup(false);
  
  }
  
  const handleGoBack = () => {
    setShowProjectListPopup(false);
  }

  const headerBtns = () => {
    return (
      <Fragment>
        {/* <Button
          onClick={() => handleSubmit(match?.params?.id)}
          className="btn btn-primary"
        >
          {localization.submitDtl}
          <img src={Images?.ArrowRight} alt="" />
        </Button> */}
        <button className="btn  btn-primary" onClick={checkInfraId}>Submit</button>

      </Fragment>
    );
  };

  return isRender ? (
    <Notfound />
  ) : (
    <Layout
      title={`Back`}
      Buttons={headerBtns}
      className={isFiled ? "requiredFileds" : ""}
      isLoading={isLoading}
      isGoback
    >
       
      {/* */}
      {projectType == 4 && 
      <>
             <LeadDetailsSupply
                  inputLabel={localization.clientName}
                  isSupply={true}
                  handleValue={handleLeadSubmit}
                  pocSubSiteTypeData={pocSubSiteTypeData}
                  pocSubSiteType={pocSubSiteType}
                  supDropDownData={supDropDownData}
                  prefilledData={viewDetails}
                />
      </>
      
                }
               
      {(projectType == 2 || projectType == 5 )? 
             <LeadDetailsApt
             inputLabel={localization.businessName}
             handleValue={handleLeadSubmit}
             isApartment={true}
             appartmentDropDown={appartmentDropDown}
             prefilledData={viewDetails}
           />
            :null}
      {projectType == 1  ? 
        <LeadDetails
        inputLabel={localization.businessName}
        isCorporate={true}
        corDropDownData={corDropDownData}
        handleValue={handleLeadSubmit}
        // isDefalut={isDefalut}
        prefilledData={viewDetails}
      />
      :null}
       
            
      <PocDetails
        handleValue={handlePocSubmit}
        appartmentDropDown={appartmentDropDown}
        prefilledData={viewDetails}
        projectType={projectType}
      />
      <Location
        locationCity={locationCity}
        cities={cities}
        locationZone={locationZone}
        zones={zones}
        locationArea={locationArea}
        areas={areas}
        locationType={locationType}
        locTypesData={locTypesData}
        handleValue={handleLocSubmit}
        locationState={locationState}
        locationPinCode={locationPinCode}
        pincodeData={pincodeData}
        getCurrentLocation={getCurrentLocation}
        latlng={latlng}
        toastMsg={toastMsg}
        prefilledData={viewDetails}
      />
      {/* <CategoryDetails
        isApartments={true}
        handleValue={handleCatSubmit}
        rwaTenureFun={rwaTenureFun}
        rwaTenureData={rwaTenureData}
        appartmentDropDown={appartmentDropDown}
        prefilledData={viewDetails}
      /> */}
  {/* {projectType} */}
        {/* {projectType == 2 ? 
                       <CategoryDetails
                       isApartments={true}
                       handleValue={handleCatSubmit}
                       rwaTenureFun={rwaTenureFun}
                       rwaTenureData={rwaTenureData}
                       appartmentDropDown={appartmentDropDown}
                       prefilledData={viewDetails}
                     />
                       : null
                    } */}
            {/* {projectType === 1 ? 
                <CategoryDetailsCorp
                isSupply={false}
                handleValue={handleCatSubmit}
                supplyNameFun={supplyNameFun}
                splNameData={splNameData}
                rwaTenureFun={rwaTenureFun}
                rwaTenureData={rwaTenureData}
                corDropDownData={corDropDownData}
                prefilledData={viewDetails}
                isEdit={true}
              />
                :null} */}

           
            {/* {projectType === 4 && projectSubType !== 9 && projectSubType !== 4 ? 
                        <CategoryDetails
                              isSupply={true}
                              supDropDownData={supDropDownData}
                              handleValue={handleCatSubmit}
                              prefilledData={viewDetails}
                            />
                            :null
            } */}

      {/* <GatesForm
        gateType={rwaTenureData.gateType}
        handleValue={handleGatesSubmit}
        prefilledData={viewDetails}
      /> */}

      {/* PROJECT LIST */}
      <ModalPop
        title={"Existing Projects"}
        show={showProjectListPopup}
        handleModalHide={closePopup}
      >
        <Fragment>
        {details &&
            Object.keys(details).length !== 0 && (
                <div className="panel-card">
                <div className="panel-heading">List of existing projects accroding to your search.</div>
                <div className="panel-body">
                    <div className="details-list">
                    <Table striped bordered hover>
                        <thead>
                        <tr>
                            <th>Project Id</th>
                            <th>Name</th>
                            <th>Address</th>
                            <th>City</th>
                            <th>State</th>
                            <th>Pincode</th>
                            <th>Action</th>
                        </tr>
                        </thead>
                        <tbody>
                        {details &&
                            details &&
                            details.map((val) => {
                            return (
                                <tr>
                                <td>{val.project_id}</td>
                                <td>{val.project_name}</td>
                                <td>{val.address}</td>
                                <td>{val.city}</td>
                                <td>{val.state}</td>
                                <td>{val.pincode}</td>
                                <td>{val?.lead_id && <a href={`${baseUrl}/contract-sales-listing/` + val.lead_id}>View Contracts</a>}</td>
                                </tr>
                            );
                            })}
                        </tbody>
                    </Table>
                    </div>
                </div>
                </div>
            )}
            
        </Fragment>
        <div className="row">
          <div className="col-md-3">
            <Button 
              width={'100%'}
              onClick={() => handleSubmit(match?.params?.id)}
              className="btn btn-primary mb-3">
                {localization.updateProject}
            </Button>
          </div>
          <div className="col-md-3">
            <Link
              to={`${baseUrl}/project-onboarding/list`}
              className="btn btn-danger"
            >
              {localization.goBackList}
            </Link>
          </div>
        </div>
        
       
       
      </ModalPop>

      {/* END PROJECT LIST */}
      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={handleModalHide}
        keyboard
        backdrop
      >
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>{localization.updateLeadSuccess}</h5>
          <Link
            to={`${baseUrl}/project-onboarding/list`}
            className="btn btn-primary mb-4"
          >
            {localization.preSales} <img src={Images?.ArrowRight} alt="" />
          </Link>
          {/* <Link
            to={`${baseUrl}/preSalesListing`}
            className="btn btn-transparent"
          >
            {localization.updateLead}
            <img src={Images?.arrowRightBlue} alt="" />
          </Link> */}
        </div>
      </ModalPop>
    </Layout>
  );
};

export default EditApartments;
